import React, { createContext, useContext } from 'react';
import type { UpdateTaskMutationVariables } from '~/graphql/types';
import type { Task } from '~/components/page/Tasks/types';
import type { FlowInAccount } from '~/hooks/useFlows';

type EmailReplyProps = {
  eventId: string;
  contact: { id: string; email: string; name: string };
  subject: string;
  from: Array<{ name?: string | null; email: string }>;
  receivedAt: string;
  onSuccess: () => void;
};

type TimelineActions = {
  onOpenTaskModal?: (task: Task | null) => void;
  onUpdateTask?: (variables: UpdateTaskMutationVariables) => Promise<void>;
  onStartLfaRequest?: (params: { eventId: string; contactId: string }) => void;
  renderEmailReply?: (props: EmailReplyProps) => React.ReactNode;
  renderFullEmail?: (eventId: string) => React.ReactNode;
  flows?: Array<FlowInAccount>;
};

const TimelineContext = createContext<TimelineActions>({});

export const TimelineProvider = TimelineContext.Provider;

export const useTimelineContext = () => useContext(TimelineContext);

export type { TimelineActions, EmailReplyProps };
